export default "assets/images/icons/performance-05cca601.svg";